import {createSlice} from '@reduxjs/toolkit';
import {
  createInpatientHospital,
  createInpatientProcedure,
  createInpatientSchedule,
  deleteInpatientHospital,
  deleteInpatientProcedure,
  getAllInpatientHospital,
  getAllInpatientProcedure,
  getAllInpatientSchedule,
  updateInpatientHospital,
  updateInpatientProcedure,
  updateInpatientSchedule
} from '../Thunk/inPatientScheduleActions';

const inPatientSlice = createSlice({
  name: 'inPatientSchedule',
  initialState: {
    inpatient: [],
    procedures: [],
    hospitals: [],
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllInpatientProcedure.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllInpatientProcedure.fulfilled, (state, action) => {
        state.loading = false;
        state.procedures = action.payload;
      })
      .addCase(getAllInpatientProcedure.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || 'Failed to fetch inpatient procedures';
      })
      .addCase(getAllInpatientSchedule.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllInpatientSchedule.fulfilled, (state, action) => {
        state.loading = false;
        state.inpatient = action.payload;
      })
      .addCase(getAllInpatientSchedule.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || 'Failed to fetch inpatient procedures';
      })
      .addCase(getAllInpatientHospital.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllInpatientHospital.fulfilled, (state, action) => {
        state.loading = false;
        state.hospitals = action.payload;
      })
      .addCase(getAllInpatientHospital.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || 'Failed to fetch inpatient hospitals';
      })
      .addCase(createInpatientSchedule.pending, state => {
        state.loading = true;
      })
      .addCase(createInpatientSchedule.fulfilled, (state, action) => {
        state.loading = false;
        // state.inpatient.push(action.payload);
      })
      .addCase(createInpatientSchedule.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || 'Failed to create or update inpatient procedure';
      })

      .addCase(updateInpatientSchedule.pending, state => {
        state.loading = true;
      })
      .addCase(updateInpatientSchedule.fulfilled, (state, action) => {
        state.loading = false;
        if (!action.payload || !action.payload.id) return; // Ensure valid data

        const index = state.inpatient.findIndex(item => item.id === action.payload.id);
        if (index !== -1) {
          state.inpatient[index] = action.payload; // Update item
        }
      })
      .addCase(updateInpatientSchedule.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || 'Failed to update inpatient';
      })
      .addCase(createInpatientProcedure.pending, state => {
        state.loading = true;
      })
      .addCase(createInpatientProcedure.fulfilled, (state, action) => {
        state.loading = false;
        state.procedures.push(action.payload);
      })
      .addCase(createInpatientProcedure.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || 'Failed to create or update inpatient procedure';
      })
      .addCase(createInpatientHospital.pending, state => {
        state.loading = true;
      })
      .addCase(createInpatientHospital.fulfilled, (state, action) => {
        state.loading = false;
        state.hospitals.push(action.payload);
      })
      .addCase(createInpatientHospital.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || 'Failed to create or update inpatient Hospital';
      })
      .addCase(updateInpatientProcedure.pending, state => {
        state.loading = true;
      })
      .addCase(updateInpatientProcedure.fulfilled, (state, action) => {
        state.loading = false;
        if (!action.payload || !action.payload.id) return; // Ensure valid data

        const index = state.procedures.findIndex(item => item.id === action.payload.id);
        if (index !== -1) {
          state.procedures[index] = action.payload; // Update item
        }
      })
      .addCase(updateInpatientProcedure.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || 'Failed to update inpatient procedure';
      })
      .addCase(updateInpatientHospital.pending, state => {
        state.loading = true;
      })
      .addCase(updateInpatientHospital.fulfilled, (state, action) => {
        state.loading = false;
        if (!action.payload || !action.payload.id) return; // Ensure valid data

        const index = state.hospitals.findIndex(item => item.id === action.payload.id);
        if (index !== -1) {
          state.hospitals[index] = action.payload; // Update item
        }
      })
      .addCase(updateInpatientHospital.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || 'Failed to update Hospital Details';
      })
      .addCase(deleteInpatientProcedure.pending, state => {
        state.loading = true;
      })
      .addCase(deleteInpatientProcedure.fulfilled, (state, action) => {
        state.loading = false;
        state.procedures = state.procedures.filter(
          procedure => procedure.id !== action.payload.id // Remove deleted item
        );
      })
      .addCase(deleteInpatientProcedure.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || 'Failed to delete inpatient procedure';
      })
      .addCase(deleteInpatientHospital.pending, state => {
        state.loading = true;
      })
      .addCase(deleteInpatientHospital.fulfilled, (state, action) => {
        state.loading = false;
        state.hospitals = state.hospitals.filter(
          hospital => hospital.id !== action.payload.id // Remove deleted item
        );
      })
      .addCase(deleteInpatientHospital.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || 'Failed to delete inpatient Hospital';
      });
  }
});

export default inPatientSlice.reducer;
